import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { SpinnerService } from '../services/spinner/spinner.service';

export const spinnerInterceptor: HttpInterceptorFn = (
	request: HttpRequest<any>,
	next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
	const spinnerService = inject(SpinnerService)

	spinnerService.show()

	return next(request).pipe(
		finalize(() => {
			spinnerService.hide()
		})
	)
}
